import { useEffect, useState } from 'react';
import { useLocation } from 'wouter';
import { AppHeader } from '../components/AppHeader.js';
import { LearnPhase } from '../components/LearnPhase.js';
import { fetchReviewToday, postReviewAnswer } from '../lib/api.js';

type Phase =
  | { kind: 'loading' }
  | { kind: 'empty' }
  | { kind: 'error'; message: string }
  | { kind: 'quiz'; words: string[] }
  | { kind: 'done'; mastered: number; redoes: number };

export function Review(): JSX.Element {
  const [, setLocation] = useLocation();
  const [phase, setPhase] = useState<Phase>({ kind: 'loading' });

  useEffect(() => {
    let cancelled = false;
    fetchReviewToday(50)
      .then((q) => {
        if (cancelled) return;
        if (q.words.length === 0) setPhase({ kind: 'empty' });
        else setPhase({ kind: 'quiz', words: q.words.map((w) => w.word) });
      })
      .catch((e) => {
        if (!cancelled) setPhase({ kind: 'error', message: (e as Error).message ?? '加载失败' });
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <>
      <AppHeader leftMode="back" />
      <main className="flex-1 flex flex-col items-center justify-center px-4 py-4 gap-4">
        {phase.kind === 'loading' ? (
          <div className="text-secondary text-hint">载入中...</div>
        ) : phase.kind === 'empty' ? (
          <>
            <div className="text-primary text-title">今日无复习</div>
            <div className="text-secondary text-hint">先去测试或学习几个词吧。</div>
            <button
              type="button"
              onClick={() => setLocation('/')}
              className="mt-4 px-5 py-2 rounded-full border border-border text-primary"
            >
              返回首页
            </button>
          </>
        ) : phase.kind === 'error' ? (
          <div className="text-secondary text-center max-w-card">
            加载失败
            <div className="text-muted text-hint mt-2 break-words">{phase.message}</div>
          </div>
        ) : phase.kind === 'quiz' ? (
          <LearnPhase
            initialWords={phase.words}
            onAnswer={async (word, correct) => {
              const ans = await postReviewAnswer({ word, quality: correct ? 4 : 0 });
              return { familiarity: ans.familiarity, familiarity_before: ans.familiarity_before };
            }}
            onComplete={(stats) => setPhase({ kind: 'done', ...stats })}
          />
        ) : (
          <>
            <div className="text-primary text-title">复习完成</div>
            <div className="text-secondary text-hint">
              今日完成 {phase.mastered} 个 · 重答 {phase.redoes}
            </div>
            <button
              type="button"
              onClick={() => setLocation('/')}
              className="mt-4 px-5 py-2 rounded-full border border-border text-primary"
            >
              返回首页
            </button>
          </>
        )}
      </main>
    </>
  );
}
